<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="postpone-reminder-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Postpone Reminder
            </h4>
          </div>

          <div class="modal-body">
            <DateFormGroup
                v-model="data.remind_at"
                name="remind_at"
                label="Remind At"
                :error="getError('remind_at')"
                format="DD.MM.YYYY HH:mm"
                original-format="YYYY-MM-DD HH:mm"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'

export default {
  components: {DateFormGroup},

  mixins: [Errors],

  props: {
    reminder: {}
  },

  data() {
    return {
      data: {},
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    reminder() {
      this.data = {...this.reminder.attributes}
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/reminders/' + this.reminder.id, {
        ...this.data,
        remind_at: moment(this.data.remind_at).format('YYYY-MM-DD HH:mm:ss'),
      })
          .then(response => {
            notify.success('The reminder was postponed')

            this.$emit('postponed', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.reminder.attributes}
    }
  }
}
</script>
